import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

export default function MobileFloatingQuote() {
  const { pathname } = useLocation();
  // Don't show on estimate wizard itself or admin pages
  if (pathname.startsWith('/estimate') || pathname.startsWith('/admin')) return null;
  return (
    <div className="md:hidden fixed bottom-3 left-3 right-3 z-30">
      <Link
        to="/estimate"
        data-testid="mobile-floating-get-quote-button"
        className="flex items-center justify-center gap-2 h-12 w-full rounded-full bg-[#C8922F] text-white font-semibold shadow-[0_14px_40px_rgba(200,146,47,0.35)] active:scale-[0.98] transition-transform"
      >
        <Sparkles className="h-4 w-4" /> Get Free Estimate — 60 sec
      </Link>
    </div>
  );
}
